export default __webpack_public_path__ + "static/background-circle-dots-and-atoms-11f223c4d8e37f42206b218fc51e9034.svg";